// Mesmo limite da API (UploadNotaFiscalCommandHandler.TamanhoMaximoArquivoBytes).
export const TAMANHO_MAXIMO_NOTA_FISCAL_BYTES = 20 * 1024 * 1024

export const MENSAGEM_TAMANHO_MAXIMO_NOTA_FISCAL = 'O arquivo ultrapassa o tamanho máximo de 20 MB.'

export function notaFiscalExcedeTamanhoMaximo(arquivo: { size: number }) {
  return arquivo.size > TAMANHO_MAXIMO_NOTA_FISCAL_BYTES
}
